module.exports = __webpack_public_path__ + "img/headphones.3d71a554.webp";